$(document).ready(function () {



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(".js-navmobile").toggleClass("active");
        $("body").toggleClass("freeze");
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * search
    // *
    // *
    $(".js-header .js-searchbutton").click(function () {
        $(".js-search").addClass("active");
        $("body").addClass("freeze");
        $('.js-searchinput').focus();
    });

    $(".js-search .js-searchbutton").click(function () {
        $(".js-search").removeClass("active open");
        $("body").removeClass("freeze");
    });


    // // Prüfen, ob das Input-Feld NICHT leer ist
    if ($('.js-searchinput').val() !== '') {
        $('.js-search').addClass('open'); 
        $("body").addClass("freeze");

        var resultCount = $('.js-search-item').length;
        $('.js-search-total').text(resultCount);
        $('.js-search-info').show();
    }
    



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderCard
    // *
    // *
    var $sliderCard = $(".js-slidercard");

    if ($sliderCard.length) {
        $sliderCard.each(function () {
            var $thisSlider = $(this);
            
            // Gemeinsamen Wrapper suchen, um die spezifischen Buttons für genau diesen Slider zu finden
            var $wrapper = $thisSlider.closest('.sliderCard');
            var $prevButton = $wrapper.find('.js-slidercard-prev');
            var $nextButton = $wrapper.find('.js-slidercard-next');
    
            $thisSlider.slick({
                infinite: false,
                arrows: true, // Muss für externe Buttons auf true stehen
                prevArrow: $prevButton, // Zuweisung des spezifischen Prev-Buttons
                nextArrow: $nextButton, // Zuweisung des spezifischen Next-Buttons
                dots: false,
                variableWidth: true,
                swipeToSlide: true, 
                touchThreshold: 100, 
                waitForAnimate: true, 
                speed: 400, 
                cssEase: 'ease-out',
                edgeFriction: 0.05,
                accessibility: true,
                focusOnSelect: false
            });
    
            // // HACK FÜR BARRIEREFREIHEIT:
            // // Slick setzt gerne tabindex="-1" auf Slides, die nicht "active" sind.
            // setTimeout(function() {
            //     $thisSlider.find('.slick-slide a').attr('tabindex', '0');
            // }, 100);
    
            // // Auch nach jedem Wechsel sicherstellen, dass sie tabbar bleiben
            // $thisSlider.on('afterChange', function() {
            //     $thisSlider.find('.slick-slide a').attr('tabindex', '0');
            // });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordionBlock
    // *
    // *
    $(".js-accordionblock-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordionblock-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordionblock-wrapper")
            .find(".js-accordionblock-content")
            .not($content)
            .attr("aria-expanded", "false");

        // setTimeout(() => {
        //     $(this)[0].scrollIntoView({ behavior: 'smooth' });
        // }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordionblock-button") && $("#" + hash).siblings(".js-accordionblock-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });



    
    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * team
    // *
    // *
    const isTouchDevice = window.matchMedia("(hover: none) and (pointer: coarse)").matches;

    // Das Skript wird nur aktiviert, wenn es ein Touch-Gerät ist
    if (isTouchDevice) {
        $('.js-team-item').on('click', function(e) {
            var $this = $(this);

            if (!$this.hasClass('open')) {
                // Erster Tap: Link blockieren
                e.preventDefault();

                // Alle anderen offenen Kacheln schließen
                $('.js-team-item').removeClass('open');

                // Diese Kachel öffnen
                $this.addClass('open');
            }
            // Zweiter Tap: 'open' ist vorhanden, preventDefault() wird übersprungen -> Link öffnet sich
        });

        // Klick ins Leere schließt die offene Kachel wieder
        $(document).on('click', function(e) {
            if (!$(e.target).closest('.js-team-item').length) {
                $('.js-team-item').removeClass('open');
            }
        });
    }

    
    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * backgroundScroller
    // *
    // *
    var $slider = $('.backgroundScroller__slidesContainer');
    var $navItems = $('.js-backgroundscroller-navitem');
    var $arrow = $('.backgroundScroller__navArrow');
    var player = $arrow.get(0);
    var masterAnimationData = null;

    // --- 1. Slick Slider Initialisierung ---
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        speed: 400, // Entspricht in etwa der Lottie-Animationsdauer
        swipe: true // Erlaubt Touch-Wischen auf Mobile
    });

    // --- 2. JSON laden ---
    $.getJSON('/assets/templates/web/img/lineani-v2.json', function(data) {
        masterAnimationData = data;
        
        // Initialer Zustand (Slide 1 aktiv, Pfeil versteckt)
        $arrow.css('opacity', 0);
        setupArrowForSection($navItems.first(), false);
    });

    // --- Hilfsfunktionen für Konturstärke (Unverändert) ---
    function updateStrokeWidth(layers, scaleFactor) {
        var baseStroke = 1; 
        var newStroke = baseStroke * scaleFactor;
        layers.forEach(function(layer) {
            if (layer.shapes) {
                layer.shapes.forEach(function(shape) { traverseShapes(shape, newStroke); });
            }
        });
    }

    function traverseShapes(shape, newStroke) {
        if (shape.ty === 'gr' && shape.it) {
            shape.it.forEach(function(item) { traverseShapes(item, newStroke); });
        }
        if (shape.ty === 'st') {
            shape.w = { a: 0, k: newStroke };
        }
    }

    // --- 3. Pfeil & Animation berechnen ---
    function setupArrowForSection($targetNavItem, playAnimation) {
        var $firstItem = $navItems.first();
        var firstCenter = $firstItem.position().left + ($firstItem.outerWidth() / 2);
        var activeCenter = $targetNavItem.position().left + ($targetNavItem.outerWidth() / 2);
        var arrowWidth = activeCenter - firstCenter;
        var finalWidth = Math.max(10, arrowWidth); 

        // 1. Breite & Position IMMER setzen (auch für Slide 1). 
        // So fährt der Pfeil im Hintergrund physisch weich zurück, während er unsichtbar wird.
        $arrow.css({
            'left': firstCenter + 'px',
            'width': finalWidth + 'px'
        });

        // 2. Lottie Handling
        if (masterAnimationData && player) {
            
            // Wenn es NICHT der erste Punkt ist -> Lottie berechnen, laden und abspielen
            if ($targetNavItem[0] !== $firstItem[0]) {
                var optimalWidth = 270; 
                var correctionFactor = optimalWidth / finalWidth; 
                
                var newData = JSON.parse(JSON.stringify(masterAnimationData));
                updateStrokeWidth(newData.layers, correctionFactor);
                
                player.load(newData); 
                player.loop = false;
                
                setTimeout(function() {
                    var lottieInstance = player.getLottie();
                    if (lottieInstance) {
                        
                        // HIER WIRD DIE GESCHWINDIGKEIT GESTEUERT (Standard ist 1)
                        // Wert erhöhen für deutlich schnellere Animation
                        lottieInstance.setSpeed(4); 
                        
                        if (playAnimation) {
                            lottieInstance.goToAndPlay(0, true);
                        } else {
                            lottieInstance.goToAndStop(0, true);
                        }
                    }
                }, 50);
            
            } else {
                // Wir sind auf Slide 1: Lottie hart auf Frame 0 zurücksetzen und stoppen!
                // Dadurch wird verhindert, dass eine laufende Animation kurz "aufblitzt".
                var existingInstance = player.getLottie();
                if (existingInstance) {
                    existingInstance.goToAndStop(0, true);
                }
            }
        }
    }

    // --- 4. Event: Klick auf Navigation ---
    $navItems.on('click', function(e) {
        e.preventDefault();
        
        // FIX: Ermittelt den Index (0-4) exakt innerhalb der 5 Links,
        // ignoriert den Lottie-Player im DOM-Baum komplett.
        var targetIndex = $navItems.index(this); 
        
        // Slick ansteuern
        $slider.slick('slickGoTo', targetIndex);
    });

    // --- 5. Event: Slick Change ---
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if (currentSlide === nextSlide) return;

        var $targetNavItem = $navItems.eq(nextSlide);
        
        $navItems.removeClass('active');
        $targetNavItem.addClass('active');

        if (nextSlide === 0) {
            // Erster Punkt: Pfeil unsichtbar machen, keine Animation triggern
            $arrow.css('opacity', 0);
            setupArrowForSection($targetNavItem, false); 
        } else {
            // Alle anderen Punkte: Pfeil einblenden und Animation starten
            $arrow.css('opacity', 1);
            setupArrowForSection($targetNavItem, true);
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    var $line = $('.js-accordion-line');
    var $canvas = $('.js-accordion-canvas');
    var isMobile = window.matchMedia('(max-width: 1200px)').matches;


    if ($canvas.length) {
        // Funktion: Content-Position und Breite anhand des Canvas setzen
        function updateLayout() {
            isMobile = window.matchMedia('(max-width: 1200px)').matches;
            
            if (isMobile) {
                // Inline Styles auf Mobile entfernen, damit CSS greift
                $('.js-accordion-content').removeAttr('style');
                return;
            }

            // 1. Wo fängt der Canvas relativ zum Dokument an?
            var canvasLeft = $canvas.offset().left;
            var canvasWidth = $canvas.width();

            $('.js-accordion-item').each(function() {
                var $item = $(this);
                var $content = $item.find('.js-accordion-content');
                
                // Wo fängt das Item relativ zum Dokument an?
                var itemLeft = $item.offset().left;

                // Differenz berechnen: So weit muss der Content nach rechts geschoben werden
                // um exakt über dem Canvas zu liegen.
                var offsetLeft = canvasLeft - itemLeft;

                $content.css({
                    'left': offsetLeft + 'px',
                    'width': canvasWidth + 'px'
                });
            });

            // Linie aktualisieren für aktives Element
            var $active = $('.js-accordion-item.active');
            if ($active.length) {
                moveLine($active);
            }
        }

        // Funktion: Linie animieren
        function moveLine($targetItem) {
            if (isMobile) return;

            var $label = $targetItem.find('.js-accordion-label');
            var $content = $targetItem.find('.js-accordion-content');

            // Vertikale Position (Mitte des Labels)
            var itemPosTop = $targetItem.position().top; 
            var labelHeight = $label.outerHeight();
            // Mitte berechnen
            var lineTop = itemPosTop +  (labelHeight / 2);

            // Horizontale Startposition (Rechts vom Label + Gap)
            var labelWidth = $label.outerWidth();
            var lineStartLeft = labelWidth + 20; // 20px Abstand zum Label

            // Horizontale Endposition (Anfang des Contents)
            // Da wir im CSS/JS den Content verschoben haben, holen wir den 'left' Wert
            var contentLeft = parseInt($content.css('left'), 10);
            
            // Breite der Linie = (Start Content) - (Ende Label) - (Kleiner Abstand rechts)
            var lineWidth = contentLeft - lineStartLeft - 20; 

            $line.css({
                'top': lineTop + 3 + 'px',
                'left': lineStartLeft + 'px',
                'width': lineWidth + 'px'
            });
        }

        // Event Listeners
        $('.js-accordion-item').on('click', function() {
            var $this = $(this);

            if (isMobile) {
                $('.js-accordion-item').removeClass('active').attr("aria-expanded", "false");
                $this.toggleClass('active').attr("aria-expanded", "true");
                return;
            }

            // Desktop Logik
            $('.js-accordion-item').removeClass('active').attr("aria-expanded", "false");
            $this.addClass('active').attr("aria-expanded", "true");
            moveLine($this);
        });

        
        // Init
        // Kurzes Timeout, damit das Rendering (Fonts etc) fertig ist
        setTimeout(function() {
            updateLayout();
        }, 50);    
        
        setTimeout(function() {
            $('.js-accordion-item:first-child').trigger("click");
        }, 400);

        // Resize Handling
        $(window).on('resize', function() {
            updateLayout();
        });
    }
    


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * helper
    // *
    // *
    $(".js-textblock-more").click(function() {
        $(this).addClass("active");
    })
    

    $(".js-hideonclick").click(function() {
        $(this).find(".js-hideonclick-target").hide();
    })


    const step = 5; // Anzahl der Einträge pro Klick
    const $items = $('.js-loadmore-item');
    const $button = $('.js-loadmore-button');

    // 1. Initialzustand: Alles über Index 4 (die ersten 5) ausblenden
    $items.slice(step).hide();

    // Falls von Anfang an weniger als 5 Items da sind, Button direkt weg
    if ($items.length <= step) {
        $button.hide();
    }

    $button.on('click', function (e) {
        e.preventDefault();

        // 2. Suche die aktuell unsichtbaren Items
        const $hiddenItems = $items.filter(':hidden');

        // 3. Zeige die nächsten 'step' Items
        $hiddenItems.slice(0, step).fadeIn();

        // 4. Prüfen, ob noch weitere unsichtbare Items übrig sind
        if ($hiddenItems.length <= step) {
            $button.fadeOut();
        }
    });
});



